import { Component,  OnInit, ViewChild } from '@angular/core';
import {FormGroup, Validators, FormControl, ValidatorFn} from '@angular/forms';
import { HttpServices } from '../../services/http-services';
import { NodeLora} from '../../interfaces/lora-devices';
import { LoraReceipt, LoraReceiptDetails} from '../../interfaces/lora-receipt';
import { CurentSetDevice } from '../../models/curentSetDevice';
import { ReceiptTableHeader } from '../../models/ReceiptsInfoTableHeaders';
import { AlertService } from '../../services/alert.service';
import { LocalDataSource } from 'ng2-smart-table';
import { Tickets } from '../../interfaces/lora-tickets-list';
import { IMyDpOptions } from 'mydatepicker';

@Component({
  selector: 'device-config-pages',
  templateUrl: 'device-config.template.html',
  styleUrls: ['device-config.styles.scss']
})

export class DeviceConfigPageComponent implements OnInit {
  optionsModel: number[];
  error: any;
  mask: string;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd.mm.yyyy',
  };
  loraDevices: NodeLora[];
  loraFilterDevices: NodeLora[];
  loraReceipt: LoraReceipt[] = [];
  tickets: Tickets[] = [];
  currentTypeArg: string = 'number';
  currentNameDevice: string = '';
  countPayLoad: string;
  argDisabled: boolean = false;
  visibleArgDate: boolean = false;
  visibleArgInput: boolean = true;
  detailsReceipt: LoraReceiptDetails = new LoraReceiptDetails(0, '', 0, '', [], '');
  sendReceiptForm: FormGroup;
  showLoader: boolean[] = [false, false, false];
  settings = ReceiptTableHeader;
  source: LocalDataSource;
  umkaData: string;

  @ViewChild ('receipt_list') receipt_list;
  @ViewChild ('send_data') send_data;
  @ViewChild ('getDatails') getDatails;

  constructor (private deviceTableService: HttpServices, private alert: AlertService) {
    this.sendReceiptForm = new FormGroup({
      'curentSelectDevice': new FormControl('', Validators.required),
      'curentSelectPort': new FormControl('', Validators.required),
      'curentReceipt': new FormControl('', Validators.required),
      'argumentInput': new FormControl(''),
      'argumentDate': new FormControl ('')
    });
  }
// [UMKA] 12:33 29.09.2018 для добавления возможности отправки пользовательской квитанции
  input(e): void {
    this.umkaData = e.target.value;
  }
  toggleArguments(e) {
   this.currentTypeArg = this.tickets.filter(item => item.id === (+e))[0].typeOfArgument;
   if (this.currentTypeArg === 'number') {
     this.visibleArgDate = false;
     this.visibleArgInput = true;
     this.sendReceiptForm.controls['argumentInput'].enable();
     this.toggleValidatorsArgumants()
   } else if (this.currentTypeArg === 'day' || this.currentTypeArg === 'month') {
     this.visibleArgDate = true;
     this.visibleArgInput = false;
     this.toggleValidatorsArgumants()
   } else if (this.currentTypeArg === 'none') {
     this.visibleArgDate = false;
     this.visibleArgInput = true;
     this.argDisabled = true;
     this.sendReceiptForm.controls['argumentInput'].disable();
     this.toggleValidatorsArgumants()
   }
  }

  toggleValidatorsArgumants() {
    const inputArg = this.sendReceiptForm.get('argumentInput');
    inputArg.clearValidators();
    const dateArg = this.sendReceiptForm.get('argumentDate');
    dateArg.clearValidators();
    const inputArgValidators: ValidatorFn[] = [Validators.required];
    const dateArgValidators: ValidatorFn[] = [Validators.required];
    if (this.currentTypeArg === 'number') inputArg.setValidators(inputArgValidators);
    else if (this.currentTypeArg === 'day' || this.currentTypeArg === 'month') dateArg.setValidators(dateArgValidators);
    else if (this.currentTypeArg === 'none') { dateArg.clearValidators(); inputArg.clearValidators() };
    inputArg.updateValueAndValidity();
    dateArg.updateValueAndValidity();
  }

  getTimeNow () {
    return new Date().toLocaleString('ru', {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    });
  }

  ngOnInit () {
    this.getAllDiveces();
    this.getDeviceReceipt();
    // this.helperHieghtBlock();
    // this.myOptions = [];
    this.getAllReceipts();
    this.mask = this.getMask();
    this.countPayLoad = this.sendReceiptForm.value.curentPayLoad;
    this.sendReceiptForm.get('argumentInput').setValue('0');
    this.toggleValidatorsArgumants();
  }

  validationChangeDevice() {
    this.sendReceiptForm.controls['curentSelectDevice'].markAsTouched();
  }

  changeDevice(name) {
    this.currentNameDevice = name;
    this.sendReceiptForm.get('curentSelectDevice').setValue(name);
  }

  getAllDiveces () {
    this.deviceTableService.getDevice().subscribe(res => {
      this.loraDevices = res.nodes;
      this.assignCopy();
      this.alert.success('Актуальный список устройств загружен');
      }, error => {
      this.alert.warn('Ошибка загрузки списка устройств!')
    })
  }

  assignCopy() {
    this.loraFilterDevices = Object.assign([], this.loraDevices);
  }

  filterDevices(value) {
    if (!value) this.assignCopy();
    this.loraFilterDevices = Object.assign([], this.loraDevices).filter(
      item => item.eui.toLowerCase().indexOf(value.toLowerCase()) > -1
    );
  }

  getAllReceipts() {
    this.deviceTableService.getAlltickets().subscribe((data: Tickets[]) => {
      this.tickets = data;
    });
  }

  umka_otkaz() {
    this.deviceTableService.stopWiting(this.sendReceiptForm.value.curentSelectDevice).subscribe(
      res => {
        this.alert.success('Больше не ждем ответа');
        this.getDeviceReceipt();
        this.sendReceiptForm.reset();
        this.currentNameDevice = '';
        this.sendReceiptForm.controls['curentSelectDevice'].markAsUntouched();
        setTimeout(() => this.showLoader[1] = false, 300);
        this.sendReceiptForm.get('argumentInput').setValue('0');
      },
      error => {console.log(error);
        this.alert.error('Ошибка на сервере');
        setTimeout(() => this.showLoader[1] = false, 300)
      }
    );


  }

  setDeviceData () {
    this.showLoader[1] = true;
    if (this.sendReceiptForm.status === 'INVALID') return 0;
    const curentDivece = new CurentSetDevice;
    curentDivece.fport = this.sendReceiptForm.value.curentSelectPort;
    curentDivece.data =  this.sendReceiptForm.value.curentReceipt;
    if (this.currentTypeArg === 'number') curentDivece.arg =  +this.sendReceiptForm.value.argumentInput;
    if (this.currentTypeArg === 'day' || this.currentTypeArg === 'month') curentDivece.arg =  this.sendReceiptForm.value.argumentDate.epoc;
    if (this.currentTypeArg === 'none') curentDivece.arg =  0;
    this.deviceTableService.setConfigDevice(this.sendReceiptForm.value.curentSelectDevice, curentDivece).subscribe(
      res => {
        this.alert.success('Квитанция успешно отправлена на сервер');
        this.getDeviceReceipt();
        this.sendReceiptForm.reset();
        this.currentNameDevice = '';
        this.sendReceiptForm.controls['curentSelectDevice'].markAsUntouched();
         setTimeout(() => this.showLoader[1] = false, 300);
          this.sendReceiptForm.get('argumentInput').setValue('0');
      },
      error => {console.log(error);
        this.alert.error('Ошибка отправки квитанции на сервер');
        setTimeout(() => this.showLoader[1] = false, 300)
      }
    );

  }

  getDeviceReceipt () {
    this.showLoader[0] = true;
    this.deviceTableService.getAllReceipts().subscribe(res => {
        this.alert.success('Список квитанций загружен успешно');
        this.loraReceipt = res;
        this.source = new LocalDataSource(this.loraReceipt);
        setTimeout(() => this.showLoader[0] = false, 300)
      },
        error => {
          this.alert.error('Ошибка загрузки списка квитанций');
          console.log(error);
          setTimeout(() => this.showLoader[0] = false, 300)
    });
  }

  getReceiptDetail(e) {
    this.showLoader[0] = true;
    this.showLoader[2] = true;
    this.deviceTableService.getReceiptDetail(e.data.idrec).subscribe((res: LoraReceiptDetails) => {
      this.detailsReceipt = res;
      setTimeout(() => {
        this.showLoader[0] = false;
        this.showLoader[2] = false
      }, 300)

    }, err => {
      console.log(err);
      setTimeout(() => {
        this.showLoader[0] = false;
        this.showLoader[2] = false
      }, 300)
    })
  }

  getMask () {
    let str = 'AA';
    for (let i = 0; i <= 49; i++) {
      str = str + '-AA'
    }
    return str;
  }

  curentPayLoadValidator(control): {[s: string]: boolean} {
    if (control.value.length % 2 !== 0) {
      return { 'curentPayLoad' : true};
    }
    return null;
  }

  helperHieghtBlock() {
    const heightWindow = window.innerHeight;
    const heightFirstBlock: number = heightWindow  - 125;
    this.receipt_list.nativeElement.style.minHeight = heightFirstBlock  + 'px';
    this.getDatails.nativeElement.style.minHeight = heightFirstBlock  - 295 + 'px';
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/pages/device-config/device-config.componenta.ts